<template>
  <svg :height="size" :width="size" fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      :stroke="color"
      d="M18.8199 9.60004H13.1805C12.0759 9.60004 11.1805 10.4955 11.1805 11.6V17.2395C11.1805 18.3441 12.0759 19.2395 13.1805 19.2395H18.8199C19.9245 19.2395 20.8199 18.3441 20.8199 17.2395V11.6C20.8199 10.4955 19.9245 9.60004 18.8199 9.60004Z"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="2"
    />
    <path
      :fill="color"
      d="M24 29.6C24 25.6 20.1177 23.8801 16.0006 23.8801C11.8831 23.8801 8 25.6 8 29.6C8 29.6 9.02816 32 16.0006 32C22.9731 32 24 29.6 24 29.6Z"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EdroneAvatarSquare",
  props: {
    size: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: "#545454",
    },
  },
});
</script>

<style scoped></style>
